// sendSettings.ts - S4 takes stakeholders and lifetime_days top-level and writes
// them over the frozen config, so values the config card edited must be lifted out.
import type { FlowConfigValues } from "../FlowDraftProvider";
import { STAKEHOLDER_KEYS } from "../config/options";
import type { SendRequest, Stakeholders } from "../types";

type SendSettings = Pick<SendRequest, "stakeholders" | "lifetime_days">;

function isStakeholders(value: unknown): value is Stakeholders {
  if (typeof value !== "object" || value === null) return false;
  const record = value as Record<string, unknown>;
  return STAKEHOLDER_KEYS.every((key) => typeof record[key] === "boolean");
}

/** Draft values where the config holds valid ones, otherwise the S2 defaults. */
export function sendSettings(config: FlowConfigValues, defaults: SendSettings): SendSettings {
  return {
    stakeholders: isStakeholders(config.stakeholders) ? config.stakeholders : defaults.stakeholders,
    lifetime_days: Number.isInteger(config.lifetime_days)
      ? (config.lifetime_days as number)
      : defaults.lifetime_days,
  };
}
